<template>
  <div v-if="isActive" style="display: block;">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TkTab',
  props: {
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: true,
    }
  },
  computed: {
    _isTab() {
      // For parent sniffing of child
      return true
    },
  },
}
</script>
